// #Professional | Rishabh Aggarwal
export const FIRST_NAME = "Rishabh"
export const LAST_NAME = "Aggarwal"
export const ALIAS = "iAmRishabh"
export const LINKEDIN = " https://www.linkedin.com/in/iamrishabhh/"
export const TWITTER = " https://x.com/im_rishabhh"
export const GITHUB = " https://github.com/rishcodelib"
export const TELEGRAM = " https://telegram.org/"
export const SNAPCHAT = " https://www.snapchat.com/add/iam.rishhiii"
export const INSTAGRAM = " https://www.instagram.com/iam.rishabhh/"
export const EMAIL = " mailto:ri.sbh23@gmail.com"
export const GMAIL = " https://mail.google.com/"
export const WEBSITE = " https://www.rishabhaggarwal.in"


// #Travel | ExploreWithRishhii
export const TRAVEL_INSTA_LINK = " https://www.instagram.com/explorewithrishhii/"
export const TRAVEL_INSTA_NAME = "ExploreWithRishhii"
export const TRAVEL_YT_NAME = 'ExploreWithRishhii'
export const TRAVEL_YT_LINK = "https://www.youtube.com/@ExploreWithRishhii"


export const TRAVEL_WEBSITE_NAME = "rishhiiitheexplorer.com/"
export const TRAVEL_WEBSITE = "https://rishhiiitheexplorer.com/"

// # Music | RishhiiiMusic
export const MUSIC_INSTA_NAME = "RishhiiMusic"
export const MUSIC_INSTA_LINK = "https://www.instagram.com/Rishhii.music/"

export const MUSIC_YT_NAME = " RishhiiiMusic"
export const MUSIC_YT_LINK = " https://www.youtube.com/@RishhiiMusic"

// # Coding | Code With Rishhiii
export const CODE_INSTA_NAME = "CodeWithRishhiii*"
export const CODE_INSTA_LINK = "https://www.instagram.com/"

export const CODE_YT_NAME = "CodeWithRishhiii"
export const CODE_YT_LINK = " https://www.youtube.com/@codewithrishhiii"
export const CODE_GIT = " https://github.com/CodeWithRishhiii"

